import { render, staticRenderFns } from "./dialog-hospitalization.vue?vue&type=template&id=5e03de14"
import script from "./dialog-hospitalization.vue?vue&type=script&lang=js"
export * from "./dialog-hospitalization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports